import cognitoBrowserDefaultHandlers, * as cognitoBrowserHandlers from './cognito/browser'

export default [...cognitoBrowserDefaultHandlers]

export { cognitoBrowserHandlers }
